/*
 * Application Messages
 *
 * This contains all the text for the Application component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.containers.Application.header',
    defaultMessage: 'Application',
  },
  absences: {
    id: 'app.containers.Application.absences',
    defaultMessage: 'Absences',
  },
});
